<script setup lang="ts">
import UIBreadcrumbs from '@/shared/ui/Breadcrumbs/index';
import type { IBreadcrumbs } from '@/shared/ui/Breadcrumbs/types';

const { t } = useI18n();
const localePath = useLocalePath();

const breadcrumbs: Ref<IBreadcrumbs[]> = ref([
  { id: 1, text: t('main'), link: localePath('/') },
  { id: 2, text: t('deliveryAndPayment'), link: '' },
]);

const items = ref([
  {
    id: 1,
    title: t('deliveryPayment.firstQuestion'),
    description: t('deliveryPayment.firstAnswer'),
  },
  {
    id: 2,
    title: t('deliveryPayment.secondQuestion'),
    description: t('deliveryPayment.secondAnswer'),
  },
  {
    id: 3,
    title: t('deliveryPayment.thirdQuestion'),
    description: t('deliveryPayment.thirdAnswer'),
  },
  {
    id: 4,
    title: t('deliveryPayment.fourthQuestion'),
    description: t('deliveryPayment.fourthAnswer'),
  },
]);

useSeoMeta({
  title: t('deliveryAndPayment'),
  ogTitle: t('deliveryAndPayment'),
  description: t('deliveryAndPaymentDescription'),
  ogDescription: t('deliveryAndPaymentDescription'),
});
</script>

<template>
  <div class="delivery-payment">
    <div class="delivery-payment__breadcrumbs">
      <UIBreadcrumbs :breadcrumbs="breadcrumbs" />
    </div>
    <section class="delivery-payment__section">
      <h1 class="delivery-payment__title">
        {{ t('deliveryAndPayment') }}
      </h1>
      <ul class="delivery-payment__list">
        <li v-for="item in items" :key="item.id" class="delivery-payment__item">
          <div class="delivery-payment__item-title">{{ item.title }}</div>
          <div class="delivery-payment__item-description">{{ item.description }}</div>
        </li>
      </ul>
    </section>
  </div>
</template>

<style lang="less">
.delivery-payment {
  .container-d();
  .flex-column(@size-x10);

  padding-top: @size-x8;
  padding-bottom: 72px;

  &__title {
    .h1();
  }

  &__section {
    .flex-column(@size-x8);
  }

  &__list {
    .flex-column(@size-x6);

    max-width: 820px;
  }

  &__item {
    .flex-column(@size-x3);
  }

  &__item-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 125%;
  }

  &__item-description {
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    color: @color-dove-gray-secondary;
  }

  @media @1024 {
    .container-m();

    gap: @size-x4;
    padding-top: @size-x6;
    padding-bottom: 48px;

    &__section {
      gap: @size-x6;
    }

    &__item {
      gap: @size-x2;
    }

    &__item-title {
      font-size: 18px;
    }

    &__item-description {
      font-size: 14px;
    }
  }
}
</style>
